<template>
  <div class="customer-details">
    <FormHeading :ordinal="`0${stepNumber}.`" :title="step.heading" />
    <div class="customer-details__inputs">
      <Input
        class="customer-details__input"
        v-for="{ name, label, placeholder } in basicInfoInputs"
        :name="`customer.${name}`"
        :key="name"
        :label="label"
        :placeholder="placeholder"
        :initialValue="initialValues[name]"
      />
    </div>
    <CheckboxGroup
      name="customer.cleaning_types"
      :options="cleaningTypes"
      :label="$t('customerDetails.fieldLabels.cleaning_types')"
      :initialValue="initialValues.cleaning_types"
    />
    <Input
      name="customer.notes"
      :label="$t('customerDetails.fieldLabels.customer_notes')"
      :placeholder="$t('customerDetails.fieldPlaceholders.customer_notes')"
      :initialValue="initialValues.notes"
    />
    <Input
      name="customer.hear_from"
      :label="$t('customerDetails.fieldLabels.hear_from')"
      :placeholder="$t('customerDetails.fieldPlaceholders.hear_from')"
      :initialValue="initialValues.hear_from"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import FormHeading from '@/components/FormHeading';
import { isShape } from '@/common/prop-validators';
import { Input, CheckboxGroup } from '@/components/common';

const { mapState } = createNamespacedHelpers('estimate');
const cleaningTypes = ['one_time', 'weekly', 'bi_weekly', 'monthly', 'spring_deep', 'move_in_out'];
const basicInfoInputs = ['first_name', 'last_name', 'email', 'phone', 'address'];

export default {
  name: 'CustomerDetailsForm',
  components: { Input, CheckboxGroup, FormHeading },
  props: {
    step: {
      type: Object,
      validator: isShape({
        component: Object,
        label: String,
        heading: String,
        id: String,
      }),
    },
    stepNumber: {
      type: Number,
    },
  },
  data() {
    return {
      basicInfoInputs: basicInfoInputs.map(inputName => ({
        name: inputName,
        label: this.$t(`customerDetails.fieldLabels.${inputName}`),
        placeholder: this.$t(`customerDetails.fieldPlaceholders.${inputName}`),
      })),
      cleaningTypes: cleaningTypes.map(type => ({
        value: type,
        label: this.$t(`customerDetails.cleaning_types.${type}`),
      })),
    };
  },
  computed: {
    ...mapState({
      initialValues: state => state.current.data.customer || {},
    }),
  },
};
</script>

<style lang="scss" scoped>
  .customer-details {
    width: 100%;

    &__inputs {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 8px;

      @include md-up {
        margin-bottom: 24px;
      }
    }

    &__input {
      flex-basis: 100%;

      @include md-up {
        &:not(:last-of-type) {
          flex-basis: calc(50% - 20px);
        }
      }
    }
  }
</style>
